export const HOPLA_URL = 'https://www.hoplacoaching.fr/supervisorApi';
export const HOPLA_BASE_URL = 'https://www.hoplacoaching.fr/api';

//export const HOPLA_BASE_URL = 'http://localhost:1234/api';
//export const HOPLA_URL = 'http://localhost:1234/supervisorApi';